import React from "react";
import { MainMenu } from "@excalidraw/excalidraw/index";
import {
  ExternalLinkIcon,
  eyeIcon,
} from "@excalidraw/excalidraw/components/icons";
import { isDevEnv } from "@excalidraw/common";
import { workspaceText } from "@excalidraw/excalidraw/components/workspaceText";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import {
  DESKTOP_CHECKOUT_URL,
  desktopCopy,
} from "@excalidraw/excalidraw/desktopFeatures";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";

import { saveDebugState } from "./DebugCanvas";
export const AppMainMenu: React.FC<{
  theme: Theme | "system";
  refresh: () => void;
}> = React.memo((props) => {
  const { langCode } = useI18n();
  return (
    <MainMenu>
      <MainMenu.ItemCustom>
        <div className="studio-menu-heading">
          {workspaceText(langCode, "files")}
        </div>
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      <MainMenu.ItemLink
        href={DESKTOP_CHECKOUT_URL}
        icon={ExternalLinkIcon}
        rel="noopener noreferrer"
      >
        {desktopCopy(langCode).buy}
      </MainMenu.ItemLink>
      <MainMenu.Separator />
      <MainMenu.ItemCustom>
        <div className="studio-menu-heading">
          {workspaceText(langCode, "shortcuts")}
        </div>
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.CommandPalette />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.Separator />
      <MainMenu.ItemLink
        href="https://opusdeskhub.com/"
        icon={ExternalLinkIcon}
        rel="noreferrer"
      >
        OpusDesk Hub
      </MainMenu.ItemLink>
      <MainMenu.Separator />
      <MainMenu.ItemCustom>
        <div className="studio-menu-heading">
          {workspaceText(langCode, "preferences")}
        </div>
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ToggleTheme allowSystemTheme theme={props.theme} />
      <MainMenu.ItemCustom>
        <LanguageList />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
      <MainMenu.DefaultItems.Preferences />
      {isDevEnv() && (
        <MainMenu.Item
          icon={eyeIcon}
          onSelect={() => {
            if (window.visualDebug) {
              delete window.visualDebug;
              saveDebugState({ enabled: false });
            } else {
              window.visualDebug = { data: [] };
              saveDebugState({ enabled: true });
            }
            props.refresh();
          }}
        >
          Visual debug
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.ClearCanvas />
    </MainMenu>
  );
});
